.supplier-header-link {
  color: var(--mantine-color-supplier-header-text);
  @media screen and (max-width: $mantine-breakpoint-md) {
    gap: 0.5rem;
  }
}

.header-logo {
  margin-right: auto;
  @media screen and (max-width: $mantine-breakpoint-md) {
    display: none;
  }
}

.supplier-footer {
  position: relative;
  min-height: 2rem;
  background-color: var(--mantine-color-supplier-header-bg);
  display: flex;
  justify-content: right;
  align-items: center;
  z-index: 10;
}
